// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2WWm2","contentWrapper":"_2-o63","heading":"-WWNH","bannerText":"_3yj1b","dates":"iPnjP","searchWrapper":"_24YZF","outer":"_3sJZN","textWrap":"_3Zy2C"};